import React, { Fragment, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import SweetAlert from 'react-bootstrap-sweetalert';
import Button from 'components/CustomButtons/Button.js';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';

import { WithApp } from 'contexts/appContext';
import { RemoveShoppingCart } from '@material-ui/icons';
import { wsPost } from 'services/WService';

const useStyles = makeStyles(styles);

/**
 * Da de baja un control de mueble, con la misma confirmación que ButtonDelete.
 *
 * La fecha no se pide: el backend usa el día en que se hace. Al confirmar, el
 * control pasa a Baja y el mueble queda libre para otro cliente.
 */
export default WithApp(function ButtonBaja(props) {
  const classes = useStyles();
  const { id, reload, showNotify } = props;

  const [alert, setAlert] = useState(null);

  const hideAlert = () => setAlert(null);

  function confirm() {
    setAlert(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title="¿Está seguro de dar de baja el mueble para este cliente?"
        onConfirm={() => {
          darDeBaja();
          hideAlert();
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      />
    );
  }

  async function darDeBaja() {
    let response = await wsPost(`base/customer-furniture/${id}/unregister`, {});

    if (response.success) {
      showNotify(response.message);
      if (!!reload && typeof reload === 'function') reload();
    } else {
      showNotify(response.message, 'error');
    }
  }

  return (
    <Fragment>
      {alert}
      <Button
        justIcon
        round
        simple
        onClick={confirm}
        color={props.themeContext.buttonColorWarning}
      >
        <RemoveShoppingCart />
      </Button>
    </Fragment>
  );
});
